module.exports = __webpack_public_path__ + "79597ae9adc8cac1925f7ff6dbb5d489.svg";